exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".revise-record {\n  text-align: left;\n  padding: 20px; }\n  .revise-record .main-title {\n    font-size: 20px;\n    font-weight: 500; }\n  .revise-record .table-content .el-pagination {\n    display: flex;\n    align-items: center; }\n", ""]);

// exports
